import { IMasterDataService } from '.'
import { IStakeholderService } from './StakeholderService';

export namespace ServicesFactory
{
    export class UserService
    {
        // Singleton pattern
        private static provider: IMasterDataService;
        public static Initialize(provider: IMasterDataService): IMasterDataService {
            if (provider == null && this.provider)
                return this.provider;

            this.provider = provider;

            return this.provider;
        }
    }

    export class StakeholderService
    {
        // Singleton pattern
        private static provider: IStakeholderService;
        public static Initialize(provider: IStakeholderService): IStakeholderService {
            if (provider == null && this.provider)
                return this.provider;

            this.provider = provider;

            return this.provider;
        }
    }
}